import { authorizationStore } from "../store/authorizationStore";

// https://gneysoftware.apps.fetias.com
// https://app01.fetias.com
// https://app02.apps.fetias.com
// https://api.inistate.com

const baseURL = 
  process && process.env && process.env.NODE_ENV === 'development' ?
    process.env.BASE_URL ? process.env.BASE_URL : 'http://localhost:2888'
  : '';
// const baseURL = 'https://api.inistate.com';
const fileUploadURL = baseURL ? `${baseURL}/api/FileUpload` : '/api/FileUpload';

const buildVersion = '220412.623';

const getConfig = async () => {
  try {
    const res = await fetch('webApp.config.json');
    const data = await res.json();
    if (data) {
      authorizationStore.dispatch('setAppConfig', data);
    }
  } catch(err) {
    console.warn(err)
  }
}

export default {
  baseURL: baseURL,
  fileUploadURL: fileUploadURL,
  buildVersion: buildVersion,
  getConfig: getConfig,
}